import {IsimpleService} from "@/services/isimple.service"

const state ={
  soon: false,
  loading: false,
  overlay: false,
  loadingAddKategori: false,
  loadingMenuDeleteAkun: false,
  modal_aktivasi: false,
  isimples: [],
  totaldata: 1,
  totalpage: 1,
  count: 0
}

const actions = {
  getIsimpleData({commit}){
    commit('setloading',true);
    if(state.isimples.length !== 0) commit('setPendings',[]);
    IsimpleService.getIsimpleUrl().then(data => {
      commit("setIsimple", data)
      commit('setloading',false);
    }).catch(err => {
      console.log(err)
      commit('setloading',false);
    })
  },

  openCloseModal({commit}){
    commit("setModalBoolean", !state.modal_aktivasi)
  },

  updateUrlModule({commit, dispatch},opt){
    commit("setModalBoolean", !state.modal_aktivasi)
    if(!opt.url_module) dispatch('alert/error', "Url module tidak boleh kosong", { root: true });
    else{
      commit('setloading',true);
      commit("setIsimple", [])
      IsimpleService.updateUrlModuleIsimple(opt).then (data => {
        dispatch('alert/success', data.msg, { root: true });
        IsimpleService.getIsimpleUrl().then(data => {
          commit("setIsimple", data)
          commit('setloading',false);
        }).catch(err => {
          console.log("=====ERROR getIsimpletUrl=====")
          console.log(err)
        })
      }).catch(err => {
        dispatch('alert/error', "Internal server error", { root: true });
        console.log("=====ERROR updateUrlModuleIsimple=====")
        console.log(err)
      })
    }
  }
}

const mutations = {
  setIsimple(state, value){
    state.isimples = value.data;
  },
  setloading(state,load) {
    state.loading = load
    state.overlay = load
  },
  setPendingCount(state,load){
    state.count = load
  },
  setPendings(state,load){
    state.isimples=load
  },
  setModalBoolean(state,load){
    state.modal_aktivasi = load
  }
}

export const Isimple = {
  namespaced: true,
  state,
  actions,
  mutations
};
